'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var utils = require('pobble-components/dist/utils');

var env = utils.getPobbleEnv();
/**
 * Since we load all external tools lazily
 *  every method in this file has a fallback to queue
 *  in case if the tool hasn't loaded yet.
 *
 * When the tool is loaded it picks up a queue and executes it
 */

var gtmDataLayerQueue = [];
var gtmDataLayer = function gtmDataLayer(dataLayer) {
  var TagManager = window.POBBLE_EXTERNAL_TOOLS && window.POBBLE_EXTERNAL_TOOLS.gtm;

  if (!TagManager) {
    gtmDataLayerQueue.push(dataLayer);
  } else {
    if (dataLayer.userId) dataLayer.userId = "account_".concat(dataLayer.userId);
    TagManager.dataLayer({
      dataLayer: dataLayer
    });
    env !== 'prod' && console.info('Metrics: GTM data layer', dataLayer);
  }
};

exports.gtmDataLayer = gtmDataLayer;
exports.gtmDataLayerQueue = gtmDataLayerQueue;
//# sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// /codebuild/output/src1478882582/src/pobble-app/client/~/pobble-components/dist/metrics/index.js